import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-6 pt-20 md:pt-24 pb-28 md:pb-32 overflow-hidden" data-id="element-50" data-mp="eibo5hi50o7c">
      <div className="max-w-reading w-full mx-auto flex flex-col items-center text-center z-10" data-id="element-51" data-mp="4lqjixa15f41">
        {/* Photo Placeholder */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="w-32 h-32 md:w-40 md:h-40 rounded-full mb-10 overflow-hidden bg-cream-dark shadow-sm border-4 border-cream" data-id="element-52" data-mp="129qvjoortvpg">
          {/* Replace with your actual photo */}
          <img src="https://cdn.magicpatterns.com/uploads/dq6cLaS3mDNSZ3F9tpWieB/Screenshot_2026-08-21_at_10.13.06_AM.png" alt="Jacob Palkin" className="w-full h-full object-cover object-center" data-id="element-53" data-mp="3cz5x6h3fwa2z" />
        </motion.div>

        <motion.div initial="hidden" animate="visible" variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.2,
            delayChildren: 0.3
          }
        }
      }} className="flex flex-col items-center" data-id="element-54" data-mp="3o73ouahgps7j">
          <motion.h1 variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: [0.21, 0.47, 0.32, 0.98]
            }
          }
        }} className="font-playfair text-[2.75rem] leading-[1.05] sm:text-5xl md:text-7xl lg:text-8xl text-charcoal tracking-tight mb-6" data-id="element-55" data-mp="35aucpsq4fbq6">
            Jacob Palkin
          </motion.h1>

          <motion.div variants={{
          hidden: {
            opacity: 0,
            scaleX: 0
          },
          visible: {
            opacity: 1,
            scaleX: 1,
            transition: {
              duration: 0.8,
              ease: 'easeOut'
            }
          }
        }} className="h-px w-24 bg-amber mb-8 origin-center" data-id="element-56" data-mp="najihr3gojgl" />

          <motion.h2 variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: [0.21, 0.47, 0.32, 0.98]
            }
          }
        }} className="text-sm md:text-xl text-sage font-medium tracking-wider uppercase mb-6" data-id="element-57" data-mp="112pwp7n20gde">
            Aspiring Legal Professional
          </motion.h2>

          <motion.p variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: [0.21, 0.47, 0.32, 0.98]
            }
          }
        }} className="text-base md:text-xl text-charcoal/70 max-w-2xl leading-relaxed font-light" data-id="element-58" data-mp="21bpmjgknzt1q">
Bay Area native currently completing the UCLA Paralegal Training
            Program and building a career in the legal field.
          </motion.p>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 text-charcoal/40" data-id="element-59" data-mp="unixf4e50eho">
        <span className="text-xs uppercase tracking-widest font-medium" data-id="element-60" data-mp="3vhfdq50udxi6">
          Scroll to read
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-61" data-mp="e7h8bcaxtko8">
          <ArrowDown size={16} className="text-amber" data-id="element-62" data-mp="3cr7fo1c01x8u" />
        </motion.div>
      </motion.div>
    </section>;
}